import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import UeberUns from './pages/UeberUns';
import Angebot from './pages/Angebot';
import Immobilien from './pages/Immobilien';
import Alphalane from './pages/Alphalane';
import Vorsorge from './pages/Vorsorge';
import Edelmetalle from './pages/Edelmetalle';
import Kontakt from './pages/Kontakt';
import Admin from './pages/Admin';
import Unsubscribe from './pages/Unsubscribe';
import { Impressum, Datenschutz, AGB } from './pages/Legal';

// Routes that should be shown without Navbar/Footer chrome
const STANDALONE_PATHS = ['/admin', '/abmelden'];

function Layout({ children }) {
  const { pathname } = useLocation();
  const standalone = STANDALONE_PATHS.some((p) => pathname.startsWith(p));
  if (standalone) return <main className="relative z-10">{children}</main>;
  return (
    <>
      <Navbar />
      <main className="relative z-10">{children}</main>
      <Footer />
    </>
  );
}

function App() {
  return (
    <HelmetProvider>
      <div className="App grain">
        <BrowserRouter>
          <ScrollToTop />
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/ueber-uns" element={<UeberUns />} />
              <Route path="/angebot" element={<Angebot />} />
              <Route path="/immobilien" element={<Immobilien />} />
              <Route path="/alphalane" element={<Alphalane />} />
              <Route path="/krypto" element={<Alphalane />} />
              <Route path="/vorsorge" element={<Vorsorge />} />
              <Route path="/edelmetalle" element={<Edelmetalle />} />
              <Route path="/kontakt" element={<Kontakt />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/abmelden" element={<Unsubscribe />} />
              <Route path="/impressum" element={<Impressum />} />
              <Route path="/datenschutz" element={<Datenschutz />} />
              <Route path="/agb" element={<AGB />} />
            </Routes>
          </Layout>
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
